import React, { useEffect, useState } from 'react'
import { reportPost, getTypeOfReports } from '../../actions/userActions';
import { connect } from 'react-redux'
import { UseComponentVisible } from '../../containers/UseComponentVisible'
import inMemoryJWT from '../../auth/inMemoryJwt'

const ReportContent = ({ history, location, reportPost, getTypeOfReports, typeOfReports, isLoadingTypeOfReports }) => {

    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getTypeOfReports()
        })
        
    },[])

    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = UseComponentVisible(false);

    var postID = location.state.postID

    const [descriptionReport, setDescriptionReport] = useState('')
    const [nameReport, setNameReport] = useState('')
    const [description, setDescription] = useState('')


    if (isLoadingTypeOfReports) {
        return (
            <div>Cargando...</div>
        )
    }
    else {
        console.log()
        return (
            <div>

                <div
                    className="parent-width"
                    onClick={() =>
                        setIsComponentVisible(true)
                    }
                >
                    <input
                        className='input-professional-create'
                        name="descriptionReport"
                        type="text"
                        value={nameReport}
                        placeholder='Problema'
                        onChange={(e) => {
                            setNameReport(e.target.value)
                        }}
                        autoComplete="off"

                    />
                </div>
                {isComponentVisible &&
                    <div className='scroll-menu modal-search-bar-economic-activities'>
                        <div className="modal-results-search-bar">
                            <div>
                                {isLoadingTypeOfReports ? <div></div> :
                                    typeOfReports.map((activity) => (
                                        <div onClick={() => {
                                            setDescriptionReport(activity._id)
                                            setNameReport(activity.description)
                                            setIsComponentVisible(false)
                                        }} className="mb-2">
                                            {activity.description}
                                        </div>
                                    ))
                                }
                            </div>

                        </div>
                        <input placeholder='descripcion'></input>
                    </div>
                }
                <input
                    className='input-professional-create'
                    name="description"
                    type="text"
                    value={description}
                    placeholder='Descripción'
                    onChange={(e) => {
                        setDescription(e.target.value)
                    }}
                    autoComplete="off"

                />
                <div>
                    <div onClick={() => {
                        if(descriptionReport!=="" && description!==""){
                            reportPost({ contentID: postID, typeOfReportsIDS: [descriptionReport], description: description }) 
                        }
                         
                         
                         }}>REPORTAR</div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
    return {
        isLoadingTypeOfReports: state.userInfo.isLoadingTypeOfReports,
        typeOfReports: state.userInfo.typeOfReports
    }
}

export default connect(mapStateToProps, { reportPost, getTypeOfReports })(ReportContent)
